import { Badge } from "@exhousing/design-system";
import { ArrowLeft } from "lucide-react";
import { Link, useParams } from "react-router-dom";

import { DocumentsPanel } from "@/components/DocumentsPanel";
import { CorrespondencePanel } from "@/components/inbox/CorrespondencePanel";
import { NotesPanel } from "@/components/NotesPanel";
import { GuarantorDetailsCard } from "@/components/party/GuarantorDetailsCard";
import { useGuarantor } from "@/hooks/api/useParties";

export function GuarantorDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { data: guarantor, isLoading, isError } = useGuarantor(id);

  if (isLoading) return <p className="text-sm text-muted-foreground">Loading…</p>;
  if (isError || !guarantor)
    return <p className="text-sm text-destructive">Guarantor not found.</p>;

  const c = guarantor.contact;
  return (
    <div className="space-y-6">
      <Link
        to="/parties"
        className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="size-4" />
        Landlords &amp; tenants
      </Link>

      <header className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="font-display text-3xl font-medium tracking-tight">
            {c.display_name}
          </h1>
          <div className="mt-2 flex gap-2">
            <Badge tone="brand">Guarantor</Badge>
            {guarantor.relationship_to_tenant && (
              <Badge tone="neutral">{guarantor.relationship_to_tenant}</Badge>
            )}
            <Badge tone={guarantor.is_active ? "success" : "neutral"}>
              {guarantor.is_active ? "Active" : "Inactive"}
            </Badge>
          </div>
        </div>
      </header>

      <GuarantorDetailsCard guarantor={guarantor} />

      <DocumentsPanel
        subjectType="guarantor"
        subjectId={guarantor.id}
        hint="Income statement, employment contract, ID."
      />
      <CorrespondencePanel entityType="contact" entityId={c.id} />
      <NotesPanel subjectType="guarantor" subjectId={guarantor.id} />
    </div>
  );
}
